import styled from 'styled-components'

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  border-bottom: ${({ dark }) =>
    dark ? '1px solid #e1e1e1' : '1px solid #EEEEEE'};
`
